import React from 'react'
import Cash from '../components/Payment/Cash'

function CashPage() {
  return (
    <>
    <Cash/>
    </>
  )
}

export default CashPage
